<!--
  ~ Copyright © 2025 Gavin Sawyer. All rights reserved.
  -->

<bowstring--divider />
<bowstring--section
  flexDirection="row"
  flexWrap="wrap-reverse">
  <bowstring--button
    appearance="raised"
    flexGrow="1"
    level="2"
    (output)="sheetComponentInput$().openModel$.set(false);">
    <bowstring--symbol input="ArrowBackward" />
    <bowstring--label
      i18n-input
      input="Cancel" />
  </bowstring--button>
  <bowstring--button
    appearance="raised"
    flexGrow="999"
    level="2"
    material="inverse"
    (output)="authenticationService.signInAnonymously(); sheetComponentInput$().openModel$.set(false);">
    <bowstring--label
      i18n-input
      input="Yes, sign out" />
  </bowstring--button>
</bowstring--section>
